import Highway from '@dogstudio/highway'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'


import { evt, utils, store } from '@/core'

const { dom, flags, device } = store
const { isMobile } = device
const { qs, qsa } = utils

import {
    scrollAnim,
    circleText,
    menuMobile,
} from '@/components'

import { lenis } from '../app'

export default class extends Highway.Renderer {
    setup() {
        this.onEnter()

        device.isMobile && dom.body.classList.add('is-mobile')

        window.onload = () => this.load()

        //MenuMobile

        menuMobile()
    }

    onEnter() {
        this.el = this.wrap.lastElementChild

        this.handleActive()
        lenis.scrollTo(0)
        lenis.start()
        //circleText(this.el)


    }

    onEnterCompleted() {
        console.log('Base')

        lenis.scrollTo(0)
        lenis.start()
        lenis.on('scroll', ({ scroll, limit, velocity, direction, progress }) => {
            evt.emit('scroll', {
                scrollY: scroll,
                velocity,
                direction
            })
        })

        function raf(time) {
            lenis.raf(time)
            requestAnimationFrame(raf)
        }
        
        requestAnimationFrame(raf)
        

        let header = qs('.header')
        evt.on('scroll', (e)=>{
            if( e.direction == 1){
                header.classList.add('up')
            }else if( e.direction == -1){
                header.classList.remove('up')
                header.classList.add('bluebg')
                if(e.scrollY < 20){
                    header.classList.remove('bluebg')
                }
            }
        })
        
       if(window.innerWidth < 800){
            let scrollMobile = 0
            lenis.on('scroll', ({ scroll, limit, velocity, direction, progress })=>{
             
                if(scroll > scrollMobile && scroll > 30){
                    header.classList.add('up')
                }else{
                    header.classList.remove('up')
                    header.classList.add('bluebg')
                    if(scrollMobile < 30){
                        header.classList.remove('bluebg')
                        header.classList.remove('up')
                    }
                }
                scrollMobile = scroll
            })  
       }
           // qsa(".scrollButton").forEach(button => {
        //     button.addEventListener("click", () => {
        //         lenis.scrollTo(window.innerHeight)
        //     })
        // })
        qsa(".js-anchor-link").forEach(b => {
            b.addEventListener("click", (e) => {
                e.preventDefault();
                
                lenis.scrollTo(b.dataset.href)
            })
        })
        this.tabsHandler()

        
        //ANCLAS LEGALES
        qsa(".js-anchor-legales").forEach(b => {
            b.addEventListener("click", (e) => {
				console.log('ale')
                e.preventDefault();
                qsa(".js-anchor-legales").forEach(b=>b.classList.remove('active'))
                b.classList.add('active')
                lenis.scrollTo(b.dataset.rel)
            })
        })

        //Filters

		const filters = qsa('.filters-content select');
        filters &&
		filters.forEach(filter => { 
			filter.addEventListener('change', () => {
				console.log(filter.name)

				console.log(filters)

				// filters.forEach(n =>{
				// 	console.log(n.name, filter.name)
				// 	if(n.name != filter.name){
				// 		n.value = 'ALL';
				// 	}
				// })

				let selectedFilter = filter.value;
				
				let itemsToHide = document.querySelectorAll(`.filtered-colocations:not(.${selectedFilter})`);
				let itemsToShow = document.querySelectorAll(`.filtered-colocations.${selectedFilter}`);

				if (selectedFilter == 'ALL') {
					itemsToHide = [];
					itemsToShow = document.querySelectorAll('.filtered-colocations');
                    filters.forEach(n => n.value = 'inicia')
				}

				itemsToHide.forEach(el => {
					el.classList.add('hide');
					el.classList.remove('show');
				});

				itemsToShow.forEach(el => {
					el.classList.remove('hide');
					el.classList.add('show'); 
				});

			});
		});

    }

    onLeave() {
        lenis.scrollTo(0)
        lenis.start()
        // if(qs('.header_burger').classList.contains('open')){
        //     qs('.header_burger').dispatchEvent(new Event('click'))
        // }
    }

    onLeaveCompleted() {
        lenis.scrollTo(0)
        lenis.start()
        ScrollTrigger.getAll().forEach(inst => inst.kill())
    }

    load() {
        this.onEnterCompleted()
        lenis.scrollTo(0)
        lenis.start()
        
    }

    /** Init components **/

    /** Handle misc **/

    handleActive() {
        qsa('.menu-item a').forEach(el => {
            el.href === location.href
                ? el.classList.add('is-active')
                : el.classList.remove('is-active')
            
        })
    }

    tabsHandler(){
        let tabs = qsa('.content_tabs')
        
        tabs && 
        tabs.forEach(t =>{
            let gbcTabs = t.getBoundingClientRect()
            let vw = (window.innerWidth - gbcTabs.width) / 2
            let buttons = t.querySelectorAll('.tabs_buttons button')
            let glider = t.querySelector('.tabs_buttons .glider')
            let content = t.querySelectorAll('.tab-main')
            buttons[0].classList.add('active')
            glider.style.width = buttons[0].getBoundingClientRect().width + 'px'
            glider.style.left = buttons[0].getBoundingClientRect().left + 'px'
            buttons.forEach(b => {
                b.addEventListener('click', () =>{ 
                    let ID = b.dataset.rel
                    let bcr = b.getBoundingClientRect()
                    
                    glider.style.width = bcr.width + 'px'

                    glider.style.left = bcr.left + 'px'
                    buttons.forEach(b => b.classList.remove('active'))
                    b.classList.add('active')
                    content.forEach(c => c.classList.remove('active'))
                    qs(`.${ID}`).classList.add('active')
                })
            })
        })
       
    }
}